import {
  CheckCircle,
  type LucideIcon,
  Loader2,
  XCircle,
  CircleMinus,
  CalendarClock,
} from 'lucide-react';

import { EdgeUpdateListItemResponse } from '@/react/portainer/environments/update-schedules/queries/list';

import { Icon, IconMode } from '@@/Icon';
import { TooltipWithChildren } from '@@/Tip/TooltipWithChildren';

import { StatusType } from '../../types';

export function UpdateScheduleStatus({
  updateSchedule,
}: {
  updateSchedule: EdgeUpdateListItemResponse;
}) {
  const { icon, mode, spin, tooltip } = getStatus(updateSchedule);

  return (
    <TooltipWithChildren message={tooltip}>
      <div>
        <Icon icon={icon} spin={spin} mode={mode} size="lg" />
      </div>
    </TooltipWithChildren>
  );
}

function getStatus(updateSchedule: EdgeUpdateListItemResponse): {
  icon?: LucideIcon;
  spin?: boolean;
  mode?: IconMode;
  tooltip?: string;
} {
  switch (updateSchedule.status) {
    case StatusType.Pending:
      return {
        icon: CalendarClock,
        mode: 'secondary',
        tooltip: 'Scheduled',
      };
    case StatusType.Failed:
      return {
        icon: XCircle,
        mode: 'danger',
        tooltip: 'Update failed',
      };
    case StatusType.Success:
      return {
        icon: CheckCircle,
        mode: 'success',
        tooltip: 'Update completed',
      };
    case StatusType.InProgress:
      return {
        icon: Loader2,
        spin: true,
        mode: 'primary',
        tooltip: 'Updating',
      };
    default:
      return {
        icon: CircleMinus,
        mode: 'warning',
        tooltip: 'Unknown status',
      };
  }
}
